'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import { useSelector } from 'react-redux';
import DocumentHead from 'ecosystem-marketplace-core/components/portals/DocumentHead';
import PrerenderReady from 'ecosystem-marketplace-core/components/prerender/PrerenderReady';
import * as CategorySlug from 'ecosystem-marketplace-core/constants/urlSlugs/CategorySlug';
import * as SuperCategorySlug from 'ecosystem-marketplace-core/constants/urlSlugs/SuperCategorySlug';
import { PublicOnly } from '../selectors/auth';
import { getCollectionSlugs } from '../selectors/collections';
import AllAppCollectionsContainer from '../storefront/containers/AllAppCollectionsContainer';
import AllReviewsPage from '../containers/detail/AllReviewsPage';
import Detail from '../containers/detail/DetailContainer';
import DetailPage from './detail/DetailPage';
import NotFoundError from './error/NotFoundError';
import Storefront from '../containers/Storefront';
import SearchResults from '../containers/storefront/SearchResults';
import StorefrontCollectionContainer from '../containers/storefront/StorefrontCollectionContainer';
import withCategoryParamValidation from '../decorators/withCategoryParamValidation';
const categorySlugRegExp = Object.values(CategorySlug).join('|');
const superCategorySlugRegExp = Object.values(SuperCategorySlug).join('|');
const pageRegExp = '[1-9][0-9]*';

const getPaginatedRoutes = route => [`${route}/page/:page(${pageRegExp})`, route];

const allCategoriesRoutes = getPaginatedRoutes('/');
const categoryRouteBase = `/:superCategory(${superCategorySlugRegExp})/:category(${categorySlugRegExp})`;
const categoryRoutes = getPaginatedRoutes(`${categoryRouteBase}?`);
const detailPageRoutes = [`${categoryRouteBase}/:slug/write-review`, `${categoryRouteBase}/:slug`, '/_detail/:slug/write-review', '/_detail/:slug', '/_preview/:slug'];
const allReviewsPageRoutes = [`${categoryRouteBase}/:slug/reviews`, '/_detail/:slug/reviews'];
const CategorySearchResults = withCategoryParamValidation(SearchResults);
const DetailContainer = withCategoryParamValidation(props => {
  const {
    match: {
      params: {
        slug
      }
    }
  } = props;
  return /*#__PURE__*/_jsx(Detail, Object.assign({}, props), slug);
});

const NotFoundRoute = () => /*#__PURE__*/_jsxs(NavMarker, {
  name: "NOT_FOUND_ERROR_LOAD",
  children: [/*#__PURE__*/_jsx(NotFoundError, {}), /*#__PURE__*/_jsx(PublicOnly, {
    children: /*#__PURE__*/_jsx(DocumentHead, {
      children: /*#__PURE__*/_jsx(PrerenderReady, {
        statusCode: 404
      })
    })
  })]
});

export default function Routes() {
  const collectionSlugs = useSelector(getCollectionSlugs);
  const collectionRoutes = useMemo(() => getPaginatedRoutes(`/:collection(${collectionSlugs.join('|')})`), [collectionSlugs]);
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Redirect, {
      exact: true,
      sensitive: true,
      from: "/all-categories",
      to: "/"
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      sensitive: true,
      path: ['/featured', ...allCategoriesRoutes, ...collectionRoutes, ...categoryRoutes],
      render: props => /*#__PURE__*/_jsx(Storefront, Object.assign({}, props, {
        children: /*#__PURE__*/_jsxs(Switch, {
          children: [/*#__PURE__*/_jsx(Route, {
            exact: true,
            path: "/featured",
            component: AllAppCollectionsContainer
          }), /*#__PURE__*/_jsx(Route, {
            path: collectionRoutes,
            component: StorefrontCollectionContainer
          }), /*#__PURE__*/_jsx(Route, {
            path: categoryRoutes,
            component: CategorySearchResults
          }), /*#__PURE__*/_jsx(Route, {
            path: allCategoriesRoutes,
            component: SearchResults
          })]
        })
      }))
    }), /*#__PURE__*/_jsx(Redirect, {
      exact: true,
      sensitive: true,
      from: `${categoryRouteBase}/:slug/review`,
      to: `${categoryRouteBase}/:slug/write-review`
    }), /*#__PURE__*/_jsx(Redirect, {
      exact: true,
      sensitive: true,
      from: "/_detail/:slug/review",
      to: "/_detail/:slug/write-review"
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      sensitive: true,
      path: [...detailPageRoutes, ...allReviewsPageRoutes],
      render: props => /*#__PURE__*/_jsx(DetailContainer, Object.assign({}, props, {
        children: /*#__PURE__*/_jsxs(Switch, {
          children: [/*#__PURE__*/_jsx(Route, {
            path: allReviewsPageRoutes,
            component: AllReviewsPage
          }), /*#__PURE__*/_jsx(Route, {
            path: detailPageRoutes,
            component: DetailPage
          })]
        })
      }))
    }), /*#__PURE__*/_jsx(Route, {
      component: NotFoundRoute
    })]
  });
}